import React from 'react';
import { useLocalizedData } from '../hooks/useTranslatedContent';
import {Link} from "react-router-dom";

function HomeTeam({ homePageData }) {
    const { getLocalized, getLocalizedArray } = useLocalizedData(homePageData);

    if (!homePageData) return null;

    const isExternalLink = (url) => typeof url === 'string' && /^https?:\/\//.test(url);


    const foundersTitle = getLocalized('foundersTitle');
    const foundersBtnName = getLocalized('foundersBtnName');
    const foundersBtnLink = getLocalized('foundersBtnLink');
    const founders = getLocalizedArray('foundersHome') || [];

    return (
        <section className="relative bg-white py-12 md:py-20 px-4 sm:px-6 lg:px-8">
            <div className="absolute inset-0 bg-black opacity-10 pointer-events-none"></div>

            <div className="relative max-w-7xl mx-auto">
                <div className="flex flex-col md:flex-row gap-8 items-center justify-between">
                    {founders.map((founder) => (
                        <div
                            key={founder.id || Math.random().toString(36).substr(2, 9)}
                            className="w-full text-center"
                        >
                            <img
                                src={founder.img || ''}
                                alt={founder.title || ''}
                                className="mx-auto object-cover object-top rounded-full shadow-lg shrink-0
    w-48 h-48
    sm:w-64 sm:h-64
     md:h-60
    lg:w-96 lg:h-96"
                            />

                            <h4 className="mt-4 text-lg font-semibold text-gray-800">
                                {founder.title || 'Founder'}
                            </h4>
                        </div>
                    ))}

                    {/* Founders Section Text and Button */}
                    <div className="w-full md:w-1/3 text-center md:text-left">
                        <h2 className="text-lg md:text-2xl font-bold text-gray-900 mb-6">
                            {foundersTitle || ''}
                        </h2>
                        {foundersBtnName && foundersBtnLink && (
                            isExternalLink(foundersBtnLink) ? (
                                <a
                                    href={foundersBtnLink}
                                    className="inline-block px-6 py-3 bg-black text-white text-sm font-medium rounded-md shadow hover:bg-gray-800 transition"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {foundersBtnName}
                                </a>
                            ) : (
                                <Link
                                    to={foundersBtnLink}
                                    className="inline-block px-6 py-3 bg-black text-white text-sm font-medium rounded-md shadow hover:bg-gray-800 transition"
                                >
                                    {foundersBtnName}
                                </Link>
                            )
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
}

export default HomeTeam;